/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It reveals the distribution's shape — its centre, spread, skewness and any peaks — which summary statistics alone can hide.`)
};

const es_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revela la forma de la distribución — su centro, dispersión, asimetría y picos — cosas que las estadísticas resumen por sí solas pueden ocultar.`)
};

const de_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es zeigt die Form der Verteilung — ihre Mitte, Streuung, Schiefe und alle Spitzen —, was zusammenfassende Statistiken allein verbergen können.`)
};

const nl_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het onthult de vorm van de verdeling — het centrum, de spreiding, de scheefheid en eventuele pieken — die samenvattende statistieken alleen kunnen verbergen.`)
};

const fr_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il révèle la forme de la distribution — son centre, sa dispersion, son asymétrie et ses pics éventuels — que les statistiques sommaires seules peuvent masquer.`)
};

const it_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivela la forma della distribuzione — il suo centro, la dispersione, l'asimmetria ed eventuali picchi — che le sole statistiche riassuntive possono nascondere.`)
};

const pt_br2_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele revela o formato da distribuição — seu centro, dispersão, assimetria e quaisquer picos — que estatísticas resumo sozinhas podem esconder.`)
};

const pt_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revela a forma da distribuição — o seu centro, dispersão, assimetria e quaisquer picos — que as estatísticas resumidas por si só podem ocultar.`)
};

const ja_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分布の形 — 中心、広がり、歪み、ピークなど — を明らかにします。これらは要約統計量だけでは見えないことがあります。`)
};

const zh_hist_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它揭示了分布的形态——中心、离散程度、偏斜度以及任何峰值——这些信息仅凭汇总统计量往往难以体现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_faq_a3", locale)
	if (locale === "en") return en_hist_faq_a3(inputs)
	if (locale === "es") return es_hist_faq_a3(inputs)
	if (locale === "de") return de_hist_faq_a3(inputs)
	if (locale === "nl") return nl_hist_faq_a3(inputs)
	if (locale === "fr") return fr_hist_faq_a3(inputs)
	if (locale === "it") return it_hist_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_hist_faq_a3(inputs)
	if (locale === "pt") return pt_hist_faq_a3(inputs)
	if (locale === "ja") return ja_hist_faq_a3(inputs)
	return zh_hist_faq_a3(inputs)
};